import React from 'react';
import SelectionControlsCore, {
  SelectionControlsCoreProps,
} from 'omakase/SelectionControls/SelectionControlsCore';

/**
 * Base checkbox component - contains the input only, and not a label.
 * To apply a label, use Checkbox.
 */
const CheckboxBase: React.FunctionComponent<SelectionControlsCoreProps> = ({ ...rest }) => {
  return <SelectionControlsCore type="checkbox" {...rest} />;
};

export default CheckboxBase;
